export const ipAddressValidation = {
    required: true,
    validators: [
        {
            type: 'length',
            length: 50,
        },
        {
            type: 'IPAddress',
            errorMessage: 'Must be a valid IP Address. Please re-enter.',
        },
        {
            type: 'customFunction',
            customValidationFunction: 'ipPortTransportCombinationValidator',
            errorMessage: 'IP address, Transport and Port combination not unique. Please review.',
        },
    ],
}

export const fqdnValidation = {
    required: true,
    validators: [
        {
            type: 'length',
            length: 256,
        }
    ],
};
